import { Alert } from 'components/ui/alert';
import { ApiErrorAlert } from 'components/ui/api-error-alert';
import { LoadingMessage } from 'components/Loader/LoadingMessage';
import PageCartoItem from 'components/PageCarto/List/PageCartoItem';
import {
  Pagination,
  PaginationContent,
  PaginationItem,
  PaginationLink,
  PaginationNext,
  PaginationPrevious,
  getSimplePaginationItems,
} from 'components/ui/pagination';
import { useAuth } from 'hooks/useAuth';
import { useService } from 'hooks/useService';
import { ApiError } from 'interfaces/api';
import { useState } from 'react';
import { useQuery } from 'react-query';
import { ContentType } from 'services/abstract';
export const PageCartoUserList = ({
  searchKeywords,
  selectedTags,
}: {
  searchKeywords: string;
  selectedTags: number[];
}) => {
  const [page, setPage] = useState(1);
  const { user } = useAuth();
  const pageCartoService = useService(ContentType.PAGE_CARTOS);
  const {
    data: response,
    isError,
    error,
    isLoading,
  } = useQuery({
    queryKey: ['page-carto-user', page, searchKeywords, selectedTags],
    queryFn: async () =>
      await pageCartoService.getPageCartoByTagsAndSearch(
        page,
        searchKeywords,
        selectedTags,
        user
      ),
  });

  const totalPages = response?.meta.pagination.pageCount || 0;
  const paginationItems = getSimplePaginationItems(page, totalPages);
  const hasPrevious = page > 1;
  const hasNext = page < totalPages;

  if (isLoading) {
    return (
      <LoadingMessage data-testid="page-carto-user-list-loading-message" />
    );
  }

  if (isError) {
    return (
      <ApiErrorAlert
        error={error as ApiError}
        data-testid="pagecarto-user-list-error-message"
      />
    );
  }

  return (
    <div>
      {!response || response.data.length === 0 ? (
        <Alert
          variant="info"
          className="bg-transparent border-transparent w-full grid justify-center items-center"
        >
          <div data-testid="pagecarto-user-list-error-message">
            Aucun contenu à afficher.
          </div>
        </Alert>
      ) : (
        <>
          <div className="grid grid-cols-3 gap-y-10 gap-x-6">
            {response.data.map((page) => {
              return <PageCartoItem key={page.id} {...page} />;
            })}
          </div>
          <div className="flex flex-row mt-5 justify-center">
            <Pagination>
              <PaginationContent
                data-testid="pagination"
                className="flex-wrap justify-center"
              >
                {hasPrevious && (
                  <PaginationItem>
                    <PaginationPrevious
                      data-testid="pagination-previous"
                      onClick={() => setPage(page - 1)}
                    />
                  </PaginationItem>
                )}
                {paginationItems.map((pageNumber) => (
                  <PaginationItem key={pageNumber}>
                    <PaginationLink
                      isActive={pageNumber === page}
                      disabled={pageNumber === page}
                      onClick={() => setPage(pageNumber)}
                    >
                      {pageNumber}
                    </PaginationLink>
                  </PaginationItem>
                ))}
                {hasNext && (
                  <PaginationItem>
                    <PaginationNext
                      data-testid="pagination-next"
                      onClick={() => setPage(page + 1)}
                    />
                  </PaginationItem>
                )}
              </PaginationContent>
            </Pagination>
          </div>
        </>
      )}
    </div>
  );
};
